import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const StaffingRequestsPage = lazy(() =>
  import('./pages/StaffingRequestsPage').then((module) => ({
    default: module.StaffingRequestsPage,
  })),
);

const StaffingRequestDetailPage = lazy(() =>
  import('./pages/StaffingRequestDetailPage').then((module) => ({
    default: module.StaffingRequestDetailPage,
  })),
);

export const staffingRoutes: RouteObject[] = [
  {
    path: 'convocatorias/solicitudes',
    element: createElement(ProtectedRoute, { view: 'staffingRequests' }),
    children: [
      { index: true, element: createElement(StaffingRequestsPage) },
      { path: ':id', element: createElement(StaffingRequestDetailPage) },
    ],
  },
];
